import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nouvaute" }
const _hoisted_2 = {
  shadow: "hover",
  class: "card-item"
}
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { style: {"width":"100%"} }
const _hoisted_5 = { class: "title-link" }
const _hoisted_6 = { class: "titles" }
const _hoisted_7 = { class: "date-news" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "card-footer" }
const _hoisted_10 = { class: "footer-text" }
const _hoisted_11 = ["href", "aria-label"]
const _hoisted_12 = ["src"]

import { getDate, getDescription, getTitle } from '@/utils/ui';
import { UseStoreNews } from '@/store/newsStore';
import { computed, ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { TEAMSRH4U_WEBPAGE } from '@/constants/liens';
import socialLinkService from '@/services/socialLinkService';
import type { SocialLinkResponse } from '@/types/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsWidget',
  async setup(__props) {

let __temp: any, __restore: any

const openNews = (id: number) => {
  window.open(`${TEAMSRH4U_WEBPAGE}${id}`, '_blank');
};

const newsStore = (
  ([__temp,__restore] = _withAsyncContext(() => UseStoreNews())),
  __temp = await __temp,
  __restore(),
  __temp
);
const currentCat = ref(6);
const currentNews = ref('');
const { t, locale } = useI18n();
const loading = ref(false);
const loadingImgs = ref(true);
const loadingIndex = ref(1);
const socialLinks = ref<SocialLinkResponse[]>([]);
const filteredNews = computed(() => newsStore.news);

const loadSocialLinks = async () => {
  try {
    const lang = locale.value?.slice(0, 2) || 'fr';
    socialLinks.value = await socialLinkService.getSocialLinks(lang);
  } catch {
    socialLinks.value = [];
  }
};

onMounted(loadSocialLinks);

const monthNames = [
  t('months.january'),
  t('months.february'),
  t('months.march'),
  t('months.april'),
  t('months.may'),
  t('months.june'),
  t('months.july'),
  t('months.august'),
  t('months.september'),
  t('months.october'),
  t('months.november'),
  t('months.december'),
];

const imagesLoad = () => {
  loadingIndex.value++;
  if (loadingIndex.value % newsStore.news.length == 0) {
    loadingImgs.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_cs_link = _resolveComponent("cs-link")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_cs_widget = _resolveComponent("cs-widget")!
  const _directive_loading = _resolveDirective("loading")!

  return (filteredNews.value.length > 0)
    ? (_openBlock(), _createBlock(_component_cs_widget, {
        key: 0,
        title: _unref(t)('dashboard.news'),
        class: "card-wrapper"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('footerNews')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialLinks.value, (social) => {
              return (_openBlock(), _createElementBlock("a", {
                key: social.id,
                href: social.link,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": 
            _unref(t)(
              'socialMedia.' +
                (social.title === 'X' ? 'X' : social.title.toLowerCase())
            )
          
              }, [
                (social.imageBase64)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: social.imageBase64,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_11))
            }), 128))
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNews.value, (newsindex) => {
              return (_openBlock(), _createBlock(_component_el_row, {
                key: newsindex.ID,
                gutter: 12,
                class: "cards",
                onClick: ($event: any) => (openNews(newsindex.ID ?? 0))
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_el_row, {
                      gutter: 6,
                      class: "news-data"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          alt: _unref(t)('images.srh4u'),
                          class: "small_img",
                          src: 
                newsindex.Image?.Url && newsindex.NewsCategoryLookupId != 6
                  ? newsindex.Image?.Url
                  : require('@/assets/images/video.png')
              ,
                          onLoad: imagesLoad
                        }, null, 40, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_cs_link, {
                              link: `${_unref(TEAMSRH4U_WEBPAGE)}${newsindex.ID}`,
                              "is-external-link": "",
                              target: "_blank",
                              "aria-label": 
                    _unref(t)('links.openLinkNewWindow', {
                      name: String(newsindex.Title),
                    })
                  ,
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("b", _hoisted_6, _toDisplayString(_unref(getTitle)(String(newsindex.Title))), 1)
                              ]),
                              _: 2
                            }, 1032, ["link", "aria-label"])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", null, _toDisplayString(_unref(getDate)(
                      newsindex.Modified ? newsindex.Modified : '',
                      monthNames
                    )), 1)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", null, _toDisplayString(_unref(getDescription)(String(newsindex.MailIntroduction ?? ''))), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ])), [
                    [_directive_loading, loadingImgs.value]
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}
}

})